import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import {
  IsString,
  IsUUID,
  IsOptional,
  MaxLength,
  Matches,
} from 'class-validator'

/**
 * DTO for creating a new subject
 */
export class CreateSubjectDto {
  @ApiProperty({
    description: 'Unique code for the subject (e.g., MATH, FRANCAIS)',
    example: 'MATH',
    maxLength: 64,
  })
  @IsString()
  @MaxLength(64)
  @Matches(/^[A-Z_]+$/, {
    message: 'Code must contain only uppercase letters and underscores',
  })
  code!: string

  @ApiProperty({
    description: 'Display label for the subject',
    example: 'Mathématiques',
    maxLength: 255,
  })
  @IsString()
  @MaxLength(255)
  label!: string

  @ApiPropertyOptional({
    description: 'Detailed description of the subject',
    example: 'Mathematics including algebra, geometry, etc.',
  })
  @IsOptional()
  @IsString()
  description?: string

  @ApiProperty({
    description: 'URL-friendly slug',
    example: 'mathematiques',
    maxLength: 255,
  })
  @IsString()
  @MaxLength(255)
  @Matches(/^[a-z0-9-]+$/, {
    message: 'Slug must contain only lowercase letters, numbers, and hyphens',
  })
  slug!: string

  @ApiPropertyOptional({
    description: 'Hex color code for UI display',
    example: '#3B82F6',
  })
  @IsOptional()
  @Matches(/^#[0-9A-Fa-f]{6}$/, { message: 'Invalid hex color' })
  color?: string

  @ApiProperty({
    description: 'Subject type UUID',
    example: '123e4567-e89b-12d3-a456-426614174000',
  })
  @IsUUID()
  typeId!: string

  @ApiPropertyOptional({
    description: 'Official reference code',
    example: 'MATHS-2024',
  })
  @IsOptional()
  @IsString()
  officialRefCode?: string
}
